module.exports = __webpack_public_path__ + "media/images/webpage/hotels/7167/plan1-1-cde92d8b05cd2cc636f7a2487b10bfcf.webp";